/* eslint-disable react/no-danger */
import React from 'react'
import PropTypes from 'prop-types'
import * as sH from 'sanitize-html'
import Obfuscate from 'react-obfuscate'
import tw from 'twin.macro'
import styled from '@emotion/styled'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const ContactItem = ({
  item: {
    title: name,
    content,
    peopleFields: { title, number, email },
    featuredImage,
  },
}) => {
  const imD = featuredImage ? getImage(featuredImage.node.localFile.childImageSharp.gatsbyImageData) : ''

  const Wrapper = styled.div`
    ${tw`bg-white mx-4 mb-8`}
  `
  const Content = styled.div`
    ${tw`px-6 md:px-8 pt-8 pb-4 bg-white flex flex-col justify-start before:content-['-'] before:bg-primary relative before:absolute before:top-[-3px] before:text-5xl before:z-30 before:w-24 before:h-[6px]`}
  `
  const JobTitle = styled.div`
    ${tw`text-primary mb-2 uppercase`}
  `
  const Name = styled.h2`
    ${tw`text-ricoDarkGray font-display -mb-3 font-light text-3xl md:text-4xl`}
  `
  const Address = styled.address`
    ${tw`not-italic text-lg pt-7 text-ricoBlack text-left mb-4`}
  `
  const AddressItem = styled(props => <Obfuscate {...props} />)`
    ${tw`no-underline block`}
  `

  return (
    <Wrapper>
      {imD && <GatsbyImage className="w-full" image={imD} alt={title} />}
      <Content>
        {title && <JobTitle dangerouslySetInnerHTML={{ __html: sH(title) }} />}
        {name && <Name dangerouslySetInnerHTML={{ __html: sH(name) }} />}
        <Address>
          {number && <AddressItem tel={number} />}
          {email && <AddressItem email={email} />}
        </Address>
        <div className="prose" dangerouslySetInnerHTML={{ __html: sH(content) }} />
      </Content>
    </Wrapper>
  )
}

ContactItem.propTypes = {
  item: PropTypes.object,
  title: PropTypes.string,
  content: PropTypes.string,
  peopleFields: PropTypes.string,
  featuredImage: PropTypes.string,
}

export default ContactItem
